import { Button } from "@material-tailwind/react";
import React, { useCallback, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { ColDef, IDateFilterParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import { allUnableToAnswerApi, threadsResponseApi } from "../../api";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";

import { RxCross2 } from "react-icons/rx";
import ShowInteractions from "./ShowInteractions";
import { delete_user_data_from_client_side } from "../../utils/common";
import { useNavigate } from "react-router-dom";
import DatePeriodSelection from "./DatePeriodSelection";
import { ShowThreadResponseProps } from "./LikeDislike";
import { allUnableToAnswerApi } from "../../api/axiosApi";
import { errorToast } from "../../utils/toastNotify";
import { ErrorMessages, ErrorType } from "../../utils/constants";
import { ToastContainer } from "react-toastify";

interface UnableToAnswerThreadProps {
    unableToAnswerInteractionsData: string[];
    open: boolean;
    setOpen: (flag: boolean) => void;
    showUserIdCol: boolean;
}
const ShowThreadResponse = ({ open, onCloseDialog, selectedThreadId, selectedIndex }: ShowThreadResponseProps) => {
    const size = window.innerWidth * 0.6;

    return (
        <Drawer
            open={open}
            onClose={onCloseDialog}
            direction="right"
            size={size}
            duration={1000}
            enableOverlay={true}
            className={`bg-gray-150 border-2 border-solid border-gray-400 mt-16 overflow-auto mb-10 scroll`}
        >
            {/* {drawerContent} */}
            <div className="">
                <div className="sticky top-0 flex z-10 w-full h-11 bg-white rounded-b-lg items-center">
                    <RxCross2 className="p-1 cursor-pointer items-start" size={36} onClick={onCloseDialog} />
                    <div className="font-bold w-full text-lg flex justify-center	text-green-800">
                        <strong>Interaction Id: </strong> &nbsp;
                        {selectedThreadId}
                    </div>
                </div>
                <div className="px-4">
                    <ShowInteractions
                        prompt={""}
                        response={""}
                        citations={""}
                        thread_id={selectedThreadId}
                        // selectedIndex={selectedIndex}
                        from={"unableToAnswer"}
                    ></ShowInteractions>
                </div>
            </div>
        </Drawer>
        // <div>
        //     <ShowInteractions prompt={""} response={""} citations={""} thread_id={selectedThreadId} selectedIndex={selectedIndex}></ShowInteractions>
        // </div>
    );
};

const UnableToAnswerThread = ({ unableToAnswerInteractionsData, open, setOpen, showUserIdCol }: UnableToAnswerThreadProps) => {
    const [selectedThreadId, setSelectedThreadId] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    // const [open, setOpen] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const onCellClicked = useCallback((params: any) => {
        setSelectedThreadId(params.data.interaction_id);
        setSelectedIndex(params.data.index);
        setIsDialogOpen(true);
        setOpen(true);
    }, []);
    const filterParams: IDateFilterParams = {
        comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
            const dateAsString = cellValue;
            if (dateAsString == null) return -1;
            const dateParts = dateAsString.split("/");
            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
                return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
                return 1;
            }
            return 0;
        },
        minValidYear: 2000,
        maxValidYear: 2021,
        inRangeFloatingFilterDateFormat: "Do MMM YYYY"
    };
    const closeDrawerRight = () => {
        setIsDialogOpen(false);
        setOpen(false);
    };
    const [colDefs, setColDefs] = useState<ColDef<any>[]>([]);

    useEffect(() => {
        setColDefs(
            showUserIdCol
                ? [
                      { field: "timestamp", headerName: "Date & Time", minWidth: 220, flex: 1 },
                      { field: "id", headerName: "User ID", minWidth: 350, hide: false }, // Show only if `showUserIdCol` is true
                      { field: "interaction_id", headerName: "Interaction Id", minWidth: 200, flex: 1 },
                      { field: "index", headerName: "Index", hide: true },
                      { field: "pm_power_user", headerName: "PM Power User", minWidth: 200, flex: 1, filter: false }
                  ]
                : [
                      { field: "timestamp", headerName: "Date & Time", minWidth: 220, flex: 1 },
                      { field: "id", headerName: "User ID", minWidth: 350, hide: true }, // Hide if `showUserIdCol` is false
                      { field: "interaction_id", headerName: "Interaction Id", minWidth: 200, flex: 1 },
                      { field: "index", headerName: "Index", hide: true },
                      { field: "pm_power_user", headerName: "PM Power User", minWidth: 200, flex: 1, filter: false }
                  ]
        );
    }, [showUserIdCol]);
    const defaultColDef: ColDef = {
        flex: 1,
        filter: true,
        editable: false,
        resizable: true
    };

    // Container: Defines the grid's theme & dimensions.
    return (
        <div className={"ag-theme-quartz"} style={{ width: "100%", height: "100%" }}>
            <AgGridReact rowData={unableToAnswerInteractionsData} columnDefs={colDefs} defaultColDef={defaultColDef} onCellClicked={onCellClicked} />
            {open && selectedThreadId && (
                <ShowThreadResponse
                    open={open}
                    onCloseDialog={closeDrawerRight}
                    selectedThreadId={selectedThreadId}
                    // selectedIndex={selectedIndex}
                ></ShowThreadResponse>
            )}
        </div>
    );
};

function UnableToAnswer() {
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [isUnableToAnswerTableVisible, setIsUnableToAnswerTableVisible] = useState(false);
    const [downloadButtonDisabled, setDownloadButtonDisabled] = useState(false);
    const [unableToAnswerInteractionsData, setUnableToAnswerInteractionsData] = useState([]);
    const [open, setOpen] = useState(false);
    const [showUserIdCol, setShowUserIdCol] = useState(true);

    const navigate = useNavigate();
    const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    async function handleUnableToAnswerSubmitButton() {
        setIsUnableToAnswerTableVisible(true);
        try {
            const unansweredThreadResponse = await allUnableToAnswerApi(formatDate(fromDate), formatDate(toDate));
            const unansweredThreadResponseInJson = await unansweredThreadResponse.data;
            if (unansweredThreadResponseInJson.admin) {
                setShowUserIdCol(true);
            } else {
                setShowUserIdCol(false);
            }
            const formattedData = unansweredThreadResponseInJson.allInteractions.map((item: any, index: number) => {
                return {
                    // SNo: index + 1,
                    timestamp: item.timestamp,
                    id: item.userId,
                    interaction_id: item.interactionId,
                    prompt: item.prompt,
                    index: item.index,
                    pm_power_user: item.pmPowerUser
                };

                // return { SNo: "", Name: "", Email: "", Organization: "", Link: "" };
            });
            setOpen(false);
            setUnableToAnswerInteractionsData(formattedData);
        } catch (error) {
            errorToast(ErrorMessages[ErrorType.WENT_WRONG]);
        }

        // setOpen(false);
        // setUnableToAnswerInteractionsData(formattedData);
    }
    const validateDates = () => {
        if (fromDate > toDate) {
            setDownloadButtonDisabled(true);
            return false;
        }
        setDownloadButtonDisabled(false);
        return true;
    };
    const handleFromDateChange = (newDate: Date) => {
        setFromDate(newDate);
        validateDates();
    };

    const handleToDateChange = (newDate: Date) => {
        setToDate(newDate);
        validateDates();
    };
    return (
        <div>
            <div className="m-1 text-center flex flex-col min-w-96">
                <strong className=" font-bold text-2xl	">Unable to Answer</strong>
                <div className="px-11">
                    <div className="py-3">
                        <span>View a list of interactions for a given period where we were unable to provide an answer.</span>
                    </div>
                    <div className=" flex w-full justify-center py-2">
                        <div className=" flex flex-wrap	gap-4 ">
                            <DatePeriodSelection toDate={toDate} fromDate={fromDate} setToDate={setToDate} setFromDate={setFromDate}></DatePeriodSelection>
                            <div className="flex gap-10 justify-center 	">
                                <div>
                                    <Button
                                        variant="text"
                                        className="min-w-36 h-10 bg-blue-400 text-white px-2 font-semibold"
                                        onClick={handleUnableToAnswerSubmitButton}
                                        disabled={downloadButtonDisabled}
                                    >
                                        submit
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="h-[70vh]">
                {isUnableToAnswerTableVisible && (
                    <UnableToAnswerThread
                        unableToAnswerInteractionsData={unableToAnswerInteractionsData}
                        open={open}
                        setOpen={setOpen}
                        showUserIdCol={showUserIdCol}
                    ></UnableToAnswerThread>
                )}
            </div>
            <ToastContainer toastStyle={{ marginTop: "8vh" }} />
        </div>
    );
}

export default UnableToAnswer;
